module.exports = __webpack_public_path__ + "img/ltkitbag-4x.87eddb6.jpg";